var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6100_4290)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6100_4290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.47 17C19.0468 15.1206 20 12.6746 20 10C20 7.32551 19.0468 4.87944 17.47 3L13 7.58663C13.4562 8.27442 13.723 9.10529 13.723 10C13.723 10.8948 13.4562 11.7256 13 12.4134L17.47 17Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.47C15.1206 19.0468 12.6746 20 10 20C7.32551 20 4.87944 19.0468 3 17.47L7.58663 13C8.27442 13.4562 9.10529 13.723 10 13.723C10.8948 13.723 11.7256 13.4562 12.4134 13L17 17.47Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53004 17L7 12.4134C6.54369 11.7256 6.27698 10.8948 6.27698 10C6.27698 9.10529 6.54369 8.27442 7 7.58663L2.53004 3C0.9532 4.87944 0 7.32551 0 10C0 12.6746 0.9532 15.1206 2.53004 17Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.27698C9.10529 6.27698 8.27442 6.54369 7.58663 7L3 2.53004C4.87944 0.9532 7.32551 0 10 0C12.6746 0 15.1206 0.9532 17 2.53004L12.4134 7C11.7256 6.54369 10.8948 6.27698 10 6.27698Z",
    fill: "#606060"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6100_4290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6100_4290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcons);
export default __webpack_public_path__ + "static/media/SupportIcons.4a770902fa3263eda3c060361559a74c.svg";
export { ForwardRef as ReactComponent };